export const APP_CONFIG = {
  kind: "trainer",
  devApiBaseUrl: "http://127.0.0.1:5000/api",
  prodApiBaseUrl: "https://app.preditwins-trainer.com/api",
  storagePrefix: "trainer_",
};